import * as api from './api';
import { FrontPriceList } from './models';
import * as MutationTypes from './mutationTypes';

export const getFrontPriceListRequest = async ({ commit, getters: { frontPriceList } }, { saleRateGuid, startDate, endDate }) => {
  if (!frontPriceList || frontPriceList.saleRateGuid !== saleRateGuid
    || frontPriceList.startDate !== startDate || frontPriceList.endDate !== endDate) {
    const response = await api.getFrontPriceListRequest(saleRateGuid, startDate, endDate);
    const frontPriceListResponse = FrontPriceList.toInstance(response.data);
    commit(MutationTypes.FRONT_PRICE_LIST_SUCCESS, frontPriceListResponse);
  }
};

export const updateFrontPriceListRequest = async ({ commit }, { pricesToUpdate }) => {
  if (pricesToUpdate.priceList.length) {
    await api.updateFrontPriceListRequest(pricesToUpdate.serialize());
    commit(MutationTypes.UPDATE_FRONT_PRICE_LIST_SUCCESS);
  }
};

export const applyFrontPriceListChanges = async ({ commit }, priceChanges) => {
  commit(MutationTypes.APPLY_FRONT_PRICE_LIST_CHANGES, priceChanges);
};
